<template>
  <div id="content">
    <div class="inner_static">
      <h1 class="tit2">Design Plan</h1>
      <ul class="lst_plan">
        <li v-for="(plan, index) in this.plans" :key="index" @click="planClick(plan, index)"
            v-bind:class="{active: index === selectedIndex}">
          <div class="ins_wrap">
            <div class="plan">
              <!-- TODO noimageでサイズが変わるので対応 -->
              <img :src="getFdImage(plan.contentsDataModelList)" @error="noImage">
            </div>
            <div class="cnt">
              <h5 class="name">{{plan.kgFdName}}</h5>
              <p class="code">{{plan.kgFdCode}}</p>
              <p class="price">{{plan.kgFdPriceMin}}</p>
              <ul class="lst_size">
                <li>
                  <strong class="item">W:</strong>{{plan.kgFdMinW}}~{{plan.kgFdMaxW}}
                </li>
                <li>
                  <strong class="item">H:</strong>{{plan.kgFdMinH}}~{{plan.kgFdMaxH}}
                </li>
                <li>
                  <strong class="item">D:</strong>{{plan.kgFdMinD}}~{{plan.kgFdMaxD}}
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
      <div class="fixed_btn_area">
        <div class="inner_static">
          <a class="btn1" @click="btnSizeInputClick()">サイズ入力へ</a>
        </div>
        <div class="inner_static" v-if="userInfo.userDebugFlg">
          <a class="btn1" @click="toSizeInput()">サイズ入力へ(webview)</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as App from '../../../utils/App'
import * as Api from '../../../utils/Api'
import {KG_URL, KG_STORAGE_KEY} from '../../../constants/App'

export default {
  data () {
    return {
      plans: [],
      selectedIndex: -1,
      userInfo: {}
    }
  },
  props: {
    selectedStyleId: Number
  },
  watch: {
    selectedStyleId: {
      immediate: true,
      handler () {
        let payload = {
          params: {
            styleId: this.selectedStyleId
          }
        }
        axios.get(KG_URL.PLANNING + '/get-plans', payload)
          .then(response => {
            if (response.data.errorMessage) {
              this.handleErrorMessage(response)
            } else {
              this.plans = response.data.data
              if (this.plans.length <= 0) {
                App.showModal({
                  title: '',
                  messages: ['プランが存在しない組み合わせです。']
                })
              }
            }
          }).catch(error => {
            Api.handleError(error)
          })
      }
    }
  },
  methods: {
    planClick: function (plan, index) {
      this.selectedIndex = index
      // 親コンポーネントのイベント実行
      this.$emit('selectPlanEvent', plan)
    },
    btnSizeInputClick: function () {
      if (this.selectedIndex < 0) {
        App.showModal({
          title: '',
          messages: [' プランを選択してください。']
        })
        return
      }
      // 親コンポーネントのイベント実行
      this.$emit('toSizeInputEvent')
    },
    // TODO Unity側のサイズ設定画面が対応完了次第削除
    toSizeInput: function () {
      if (this.selectedIndex < 0) {
        App.showModal({
          title: '',
          messages: [' プランを選択してください。']
        })
        return
      }
      this.$router.push('/kagull/planning/size')
    },
    getFdImage: function (contentsDataModelList) {
      return !contentsDataModelList || contentsDataModelList.length <= 0
        ? App.getKagullResource('noimage.svg')
        : App.getContentsResource(contentsDataModelList[0].corpId + '/' + contentsDataModelList[0].contentsImgMid)
    },
    noImage: function (element) {
      element.target.src = App.getKagullResource('noimage.svg')
    }
  },
  created: function () {
    this.userInfo = App.getLocalStorage(KG_STORAGE_KEY.USER_INFO)
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/components/planning/PlanPanel.vue